import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Exhibition extends Component {
    render() {
        return (
            <div className='container'>
                <h1>Exhibition</h1>
                <p>Click <Link to="/exhibition/awards">here</Link> to see the 2024 award winners.</p>
                <img src='../../../images/exhibition/Poster_2025.jpeg' width="100%" alt="poster" className="img-responsive" />
                <br />
                <br />
                <br />
            </div>
        );
    }
}

export default Exhibition;


// WEBPACK FOOTER //
// ./src/pages/exhibition.jsx